module.exports = __webpack_public_path__ + "egg-box.png?03b97c88953e7287c9d7d158b8fe5a89";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/egg-box.png
// module id = 49
// module chunks = 0